import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const SaveButton = ({ onClick, disabled }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main primary-button'} onClick={onClick} disabled={disabled}>
            {t('common:buttons.save')}
        </button>
    );
}